export default __webpack_public_path__ + "static/media/undraw_opinion_re_jix4.71d92f86.svg";